import {MenuConstants} from './constants';

export const getAdminMenuList = (uView) => {
    var acionMenu = [];

    if (uView.can_manage_company_profile)
        acionMenu.push(MenuConstants.ManageCompanyProfile);

    if (uView.can_send_b2b_relationship_request || uView.can_accept_reject_b2b_relationship_request || uView.can_manage_contracts || uView.can_de_associate_b2b_relationship ||
        uView.can_add_remove_organization_from_exclude_list || uView.can_view_b2b_workload)
        acionMenu.push(MenuConstants.ManageRelationships);

    if (uView.can_add_user || uView.can_re_assign_a_user || uView.can_edit_user || uView.can_block_a_user || uView.can_reset_password || uView.can_view_workload)
        acionMenu.push(MenuConstants.ManageUsers);

    // if (uView.CanCreateDailyActivityAssignmentRules || uView.CanCreateCATBidActivityAssignmentRules || uView.CanCreateCATActivityAssignmentRules)
    //     acionMenu.push(MenuConstants.RuleSet);
        
    // if (uView.can_add_note_templates)
    //     acionMenu.push(MenuConstants.NoteTemplates);

    if (uView.invite_people_to_access_community)
        acionMenu.push(MenuConstants.AccessToCommunities);

    if (process.env.enable_rule_engine === "true")
    {
        if (uView.can_manage_rules)
            acionMenu.push(MenuConstants.RuleEngine);
    }

    if (process.env.enable_associated_party === "true")
    {
        if (uView.can_create_party || uView.can_delete_party)
            acionMenu.push(MenuConstants.Party);
    }

    // if (uView.can_add_custom_fields)
    //     acionMenu.push(MenuConstants.ManageTemplate);

    if (uView.can_manage_inbox)
        acionMenu.push(MenuConstants.ManageInbox);

    if (uView.can_manage_settings)
        acionMenu.push(MenuConstants.Settings);
    
    return acionMenu;
}

export const checkPermissionForAdminMenu = (uView) => {
    if(uView.can_manage_company_profile || uView.can_send_b2b_relationship_request || uView.can_accept_reject_b2b_relationship_request || 
        uView.can_manage_contracts || uView.can_de_associate_b2b_relationship || uView.can_add_remove_organization_from_exclude_list || 
        uView.can_add_user || uView.can_re_assign_a_user || uView.can_edit_user || uView.can_block_a_user || uView.can_manage_settings || 
        uView.any || uView.can_view_b2b_workload || uView.can_view_workload || uView.can_manage_rules || 
        uView.can_create_party || uView.can_delete_party
    ){
        return true;
    }

    return false;
}